<mat-sidenav-container class="fh notifications-page">
  <mat-sidenav
    id="sidenavContact"
    #sidenavContact
    mode="over"
    (closed)="onSidenavClose()"
    [opened]="profile_id ? true : false"
    position="end"
  >
    <div class="appear_1">
      @if (userAccount) {
        <app-profile
          data-testid="connection-profile"
          [attr.data-user-id]="profile_id"
          [contactId]="profile_id"
          [isDirectory]="true"
          [userAccount]="userAccount"
          (exit)="sidenavContact.close()"
          (accept)="onAccept($event)"
        >
        </app-profile>
      }
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="fh page">
    <div class="page-content">
      <div class="side content"></div>
      <div class="middle content">
        <div class="title">Activity Feed</div>
        <app-activity-feed-list></app-activity-feed-list>
        @if (notificationsService.hasNextPage) {
          <div>
            @if (!isLoadingMore) {
              <button
                class="fw celo-hoverable"
                mat-button
                (click)="loadMoreActivities()"
              >
                Load more
              </button>
            } @else {
              <app-basic-spinner></app-basic-spinner>
            }
          </div>
        }
      </div>
      <div class="side content">
        <div class="title">Connection Requests</div>
        @if (
          profileService.pendingConnections &&
          profileService.pendingConnections.length
        ) {
          <div>
            @if (userAccount) {
              <app-connections-list
                [userAccount]="userAccount"
                [list]="profileService.pendingConnections"
                [floatRight]="false"
              ></app-connections-list>
            }
            @if (
              profileService.pendingConnections &&
              profileService.pendingConnections.length &&
              profileService.pendingConnections.length < total
            ) {
              <div>
                <button
                  class="fw celo-hoverable"
                  mat-button
                  (click)="loadMore()"
                >
                  Load more
                </button>
              </div>
            }
          </div>
        }
        @if (
          !profileService.pendingConnections ||
          !profileService.pendingConnections.length
        ) {
          <div class="subtitle">No pending connection requests.</div>
        }
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
